const items = {
  "article.lable": "article",
  "article.fields.article.count.label": "article count",
};

export default items;
